import { reflectComponentType, Type } from '@angular/core';

const screensWithoutMenus = new Set([
  'app-video-appointment',
  'app-signup-invitation-landing',
  'app-setup-platform-overview',
  'app-login',
  'app-auth-callback',
  'app-logged-out',
  'app-validate-email',
  'app-salesforce-launch',
  'app-salesforce-not-authorized',
  'app-video-appointment-launch',
  'app-video-appointment-launch-unavailable',
  'app-embedded-completed',
  'app-not-found',
]);

export function isScreenWithoutMenus(event: unknown): boolean {
  if (typeof event !== 'object' || event === null) {
    return false;
  }

  const component = reflectComponentType(event.constructor as Type<unknown>);
  return component !== null && screensWithoutMenus.has(component.selector);
}
